import defaultTheme from './themes/default';

const themeDef = {
  defaultTheme,
};

export default themeDef;
